export const laborsReducer = (state = {loading:true,result:null,labors:null,labor:null} , action) => {
    switch (action.type) {
        case 'LABOR_SEND_SUCCESS':
            return {
                ...state,
                loading:false,
                result: action.payload
            }
        case 'LABORS_GET_SUCCESS':
            return {
                ...state,
                loading:false,
                labors: action.payload
            }
        case 'LABOR_GET_DETAIL_SUCCESS':
            return {
                ...state,
                loading:false,
                labor: action.payload
            }
        case 'LABORS_BY_CROP_SUCCESS':
            return {
                ...state,
                loading:false,
                labors: action.payload
            }
        case 'LABOR_DELETE_SUCCESS':
            return {...state,
                loading:false,
                result: action.payload.message,
                labors: state.labors.filter(labor => labor._id !== action.payload.idLabor)
            }
        case 'LABOR_DELETE_NOT_SUCCESS':
            return {...state,
                loading: false,
                result: action.payload
            }
        case 'LABOR_RESET_RESULT':
            return {...state,
                result: null
            }
        case 'LABOR_LOADING':
            return {
                ...state,
                loading:true
            }
        case 'LABOR_ERROR':
            return {
                ...state,
                loading:false
            }
        default:
            return state
    }
}

